import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name trustyle.wireframe-cell */
import * as React from 'react';
import { css, keyframes } from '@emotion/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var loading = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    background-position: 100% 0\n  }\n  100% {\n    background-position: -100% 0\n  }\n"])));
var wireFrameCellCss = css({
  '.load': {
    backgroundImage: 'linear-gradient(to right, #DFDFE1, #F2F2F3, #DFDFE1)',
    backgroundSize: '200% 100px',
    animation: "".concat(loading, " 1.5s infinite ease")
  }
});

var WireFrameCell = function WireFrameCell(_ref) {
  var styles = _ref.styles;
  return _jsx("span", {
    css: wireFrameCellCss,
    sx: _objectSpread({
      display: 'block',
      backgroundColor: '#DFDFE1'
    }, styles),
    children: _jsx("span", {
      className: 'load',
      sx: {
        width: '100%',
        height: '100%',
        display: 'block'
      }
    })
  });
};

export default WireFrameCell;
//# sourceMappingURL=index.js.map